import {Component} from 'react'

import TodoItem from '../TodoItem'
import './index.css'

const initialTodosList = [
  {
    id: 1,
    title: 'Book the ticket for today evening',
    checked: false,
  },
  {
    id: 2,
    title: 'Rent the movie for tomorrow movie night',
    checked: false,
  },
  {
    id: 3,
    title: 'Confirm the slot for the yoga session tomorrow morning',
    checked: false,
  },
  {
    id: 4,
    title: 'Drop the parcel at Bloomingdale',
    checked: false,
  },
  {
    id: 5,
    title: 'Order fruits on Big Basket',
    checked: false,
  },
  {
    id: 6,
    title: 'Fix the production issue',
    checked: false,
  },
  {
    id: 7,
    title: 'Confirm my slot for Saturday Night',
    checked: false,
  },
  {
    id: 8,
    title: 'Get essentials for Sunday car wash',
    checked: false,
  },
]

class SimpleTodos extends Component {
  state = {
    todosList: initialTodosList,
    inputTodo: '',
  }

  enterInput = event => {
    this.setState({inputTodo: event.target.value})
  }

  updateTodo = (id, updatedTitle) => {
    this.setState(prevState => ({
      todosList: prevState.todosList.map(each =>
        each.id === id ? {...each, title: updatedTitle} : each,
      ),
    }))
  }

  deleteTodo = id => {
    this.setState(prevState => ({
      todosList: prevState.todosList.filter(each => each.id !== id),
    }))
  }

  handleToggle = id => {
    this.setState(prevState => ({
      todosList: prevState.todosList.map(each =>
        each.id === id ? {...each, checked: !each.checked} : each,
      ),
    }))
  }

  addTodo = () => {
    const {inputTodo, todosList} = this.state

    if (inputTodo.trim() === '') {
      return
    }

    const parts = inputTodo.trim().split(' ')
    const lastPart = parts[parts.length - 1]

    let count = 1
    let title = inputTodo.trim()

    // check if last word is a number
    if (!Number.isNaN(Number(lastPart))) {
      count = Number(lastPart)
      title = parts.slice(0, -1).join(' ')
    }

    if (title === '' || count < 1) {
      return
    }

    const newTodos = []

    for (let i = 0; i < count; i += 1) {
      newTodos.push({
        id: Date.now() + i,
        title,
        checked: false,
      })
    }

    this.setState({
      todosList: [...todosList, ...newTodos],
      inputTodo: '',
    })
  }

  render() {
    const {todosList, inputTodo} = this.state

    return (
      <div className="app-con">
        <div className="todo-con">
          <h1 className="heading">Simple Todos</h1>

          <div className="input-con">
            <input
              type="text"
              value={inputTodo}
              onChange={this.enterInput}
              className="input-sec"
              placeholder="Enter Your todo Task"
            />
            <button type="button" onClick={this.addTodo} className="add-btn">
              Add
            </button>
          </div>

          <ul className="todo-List">
            {todosList.map(each => (
              <TodoItem
                key={each.id}
                todoDetails={each}
                deleteTodo={this.deleteTodo}
                handleToggle={this.handleToggle}
                updateTodo={this.updateTodo}
              />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}
export default SimpleTodos
